export interface SessionCreationSuccess {
  data: { session_id: string };
  message: string;
}

export enum SessionEventCode {
  PhotoScan = "Photo Scan",
}
